import React, { useContext, useMemo } from 'react';
import { TabContext } from '../components/TabbedLayout';
import withAuth from '../common/auth';
import { PurchaseEntryForm } from './Purchase';

const parsePurchaseEditPath = (path) => {
  if (!path?.startsWith('purchaseedit/')) {
    return null;
  }

  const parts = path.replace('purchaseedit/', '').split('/');
  if (parts.length < 2 || !parts[0] || !parts[1]) {
    return null;
  }

  return {
    invoiceNo: decodeURIComponent(parts[0]),
    sequence: decodeURIComponent(parts[1]),
    editNo: parts[2] !== undefined && parts[2] !== '' ? parseInt(parts[2], 10) : 0,
  };
};

const PurchaseEdit = ({ tabPath: tabPathProp, tabId }) => {
  const tabContext = useContext(TabContext);
  const activeTabPath = tabPathProp
    || tabContext?.tabs?.find((tab) => tab.id === tabContext?.activeTabId)?.path
    || '';

  const editParams = useMemo(
    () => parsePurchaseEditPath(activeTabPath),
    [activeTabPath]
  );

  if (!editParams?.invoiceNo || !editParams?.sequence) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500 p-8 text-center">
        <p>Invalid purchase edit session. Open a bill from Purchase Bill Wise or Purchase Item Wise report.</p>
      </div>
    );
  }

  return <PurchaseEntryForm mode="edit" editParams={editParams} tabId={tabId} />;
};

export default withAuth(PurchaseEdit);
